import {IComponentLayout, IRenderContext, RenderContext} from '../../RenderContext';
import {Bounds} from '../../Core';

export interface ISensorChartComponentLayout extends IComponentLayout {
		labels: {
			top: Bounds,
			bottom: Bounds
		}
	}

	export class SensorChartRenderContext extends RenderContext implements IRenderContext<ISensorChartComponentLayout> {

		public constructor(element: string | Element | JQuery) {
			super(element);
		}

		protected componentLayout: ISensorChartComponentLayout;

		public getComponentLayout(): ISensorChartComponentLayout {
			return this.componentLayout;
		}

		protected createComponentLayout(): ISensorChartComponentLayout {
			return {
				plot: new Bounds(),
				labels: {
					top: new Bounds(),
					bottom: new Bounds()
				}
			}
		}

		protected layoutComponents(){
			var margins = 0;
			var width = this.getWidth() - 2 * margins;
			var height = this.getHeight() - 2* margins;
			var labelsHeight = 30;

			var layout = this.getComponentLayout();

			layout.labels.top.top = margins;
			layout.labels.top.height = labelsHeight;
			layout.labels.top.left = margins;
			layout.labels.top.width = width;

			// this.bounds.labels.bottom.top = depends on plot
			layout.labels.bottom.left = margins;
			layout.labels.bottom.width = width;
			layout.labels.bottom.height = labelsHeight;

			layout.plot.top = layout.labels.top.top + layout.labels.top.height;
			layout.plot.left = margins;
			layout.plot.width = width;
			layout.plot.height = height - layout.labels.top.height
				- layout.labels.bottom.height;

			layout.labels.bottom.top = layout.plot.top + layout.plot.height;
		}
	}
